import './navigation.css';
import { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { Menubar } from 'primereact/menubar';
import { MenuItem } from 'primereact/menuitem';
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';
import { ChevronDownIcon } from 'primereact/icons/chevrondown';
import { ChevronRightIcon } from 'primereact/icons/chevronright';
import { ILanguageOption } from './interfaces/ILanguageOption';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../state/store';
import { changeLanguage } from '../../../state/slices/languageSlice';
import { Dictionary } from '../../../common/dictionary';
import { setPhrases } from '../../../state/slices/phrasesSlice';

const NavigationComponent = () => {
  const navigate = useNavigate();
  const dispatch: AppDispatch = useDispatch<AppDispatch>();
  const companyLogo: JSX.Element = <img src={'./sharpit_ltd_logo.jpg'} alt="Sharp IT Ltd. logo" />
  const language: string = useSelector((state: RootState) => state.language.value);
  const phrases = useSelector((state: RootState) => state.phrases.value);
  
  const languageOptions: Array<ILanguageOption> = [
    { name: 'Български', code: 'BG' },
    { name: 'English', code: 'UK' },
  ]

  const selectedLanguageOptionInitialState = language === "BG" 
    ? languageOptions[0]
    : languageOptions[1];

  const [selectedLanguage, setSelectedLanguage] = useState<ILanguageOption>(selectedLanguageOptionInitialState);

  const items: Array<MenuItem> = [
    {
      label: phrases[1], // Home
      icon: 'pi pi-home',
      command: () => {
        navigate('/home');
      }
    },
    {
      label: phrases[2], // About us
      icon: 'pi pi-users',
      command: () => {
        navigate('/about-us');
      }
    },
    {
      label: phrases[3], // Services
      icon: 'pi pi-cog',
      command: () => {
        navigate('/services');
      }
    },
    {
      label: phrases[4], // Contact us
      icon: 'pi pi-envelope',
      command: () => {
        navigate('/contact-us');
      }
    },
    {
      label: phrases[38], // Open positions
      icon: 'pi pi-user-plus',
      command: () => {
        navigate('/open-positions')
      }
    }
  ]

  function languageOptionTemplate(option: ILanguageOption): JSX.Element {
      return (
        <div className="flex align-items-center">
          <div className='flag-container'>
            {
              option?.name === 'Български'
              ? <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 5 3"><path fill="#fff" d="M0 0h5v3H0z"/><path fill="#00966E" d="M0 1h5v2H0z"/><path fill="#D62612" d="M0 2h5v1H0z"/></svg>
              : <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 60 30"><clipPath id="a"><path d="M0 0v30h60V0z"/></clipPath><clipPath id="b"><path d="M30 15h30v15zv15H0zH0V0zV0h30z"/></clipPath><g clipPath="url(#a)"><path d="M0 0v30h60V0z" fill="#012169"/><path d="m0 0 60 30m0-30L0 30" stroke="#fff" strokeWidth="6"/><path d="m0 0 60 30m0-30L0 30" clipPath="url(#b)" stroke="#C8102E" strokeWidth="4"/><path d="M30 0v30M0 15h60" stroke="#fff" strokeWidth="10"/><path d="M30 0v30M0 15h60" stroke="#C8102E" strokeWidth="6"/></g></svg>
            }
          </div>
            <div>{option?.name}</div>
        </div>
      );
  }

  function setLanguage(event: DropdownChangeEvent) {
    const selectedLanguage: string = event.value.name === 'Български' ? 'BG' : 'EN';
    localStorage.setItem('language', selectedLanguage);
    dispatch(changeLanguage(selectedLanguage));
    setSelectedLanguage((previous: ILanguageOption) => event.value)
  }

  useEffect(() => {
    dispatch(setPhrases(Dictionary.getPhrases(language)));
  }, [language]);

  useEffect(() => {
    // This element is internally rendered by PrimeReact and we can not add "ref" attribute or attach event from JSX.
    const companyLogoImg: HTMLImageElement | null = document.querySelector('.p-menubar-start > img');

    if (companyLogoImg !== null) {
      companyLogoImg.addEventListener('click', () => {
        navigate('/home');
      });
    }
  }, []);

  const end: JSX.Element = (
    <Dropdown 
      value={selectedLanguage}
      onChange={(event: DropdownChangeEvent) => setLanguage(event)}
      options={languageOptions}
      optionLabel="name"
      placeholder="Select language"
      valueTemplate={languageOptionTemplate}
      itemTemplate={languageOptionTemplate}
      className="w-full md:w-14rem"
      dropdownIcon={(opts: any) => {
        return opts.iconProps['data-pr-overlay-visible'] 
          ? <ChevronRightIcon {...opts.iconProps} /> 
          : <ChevronDownIcon {...opts.iconProps} />;
      }} 
    />
  );

  return <>
    <nav>
      <Menubar start={companyLogo} model={items} end={end} />
	  </nav>
  </>
}

export default NavigationComponent